import React, { useContext, useEffect, useState } from 'react'
import { GetEPaymentStatusName } from '../../../enumCollections/EPaymentStatus'
import { GetELedgerAssetSalary, GetELedgerAssetSalaryName } from '../../../enumCollections/ELedgerAssetSalary'
import { EmptyData } from '../../../commonLib/EmptyData'
import { MyAlert } from '../../../commonLib/MyAlert'
import Moment from 'react-moment'
import { PagingEmpty } from '../../../commonLib/PagingEmpty'
import { UserView } from '../../Global/Elements/UserView'
import { StatusView } from '../../../commonLib/StatusView'
import { ContactView } from '../../Global/Elements/ContactView'
import { Link, useParams } from 'react-router-dom'
import AppToaster from '../../../commonLib/AppToaster'
import * as salaryVoucherCrud from '../../../_crud/vouchers/salaryVoucherCrud'
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext'
import GetCurrentDateForSearch from '../../../commonLib/dateFormat'
import DatePicker from "react-datepicker";
import { TextBoxTranslater } from '../../../commonLib/TextBoxTranslater'

export function SalaryItemView({ paid, pending, salaryVoucher, voucherPayment, doRefresh, advance, defect, isPrint = false }) {
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const { id } = useParams()
    const [empty, setEmpty] = useState(false);

    const initItems = {
        voucherId: id,
        receivedDate: new Date(GetCurrentDateForSearch(0)),
        amount: 0,
        fiscalYear: "a",
        fromLedgerId: 6,
        note: ""
    }
    const [salaryItem, setSalaryItem] = useState(initItems);

    useEffect(() => {
        setEmpty(false)
    }, [empty]);

    function setAmount() {
        if (salaryItem.amount) {
            if (salaryItem.fromLedgerId == 9) {
                if (advance) {
                    if (salaryItem.amount > advance.remainingAdvance) {
                        if (advance.remainingAdvance > pending)
                            setSalaryItem({ ...salaryItem, amount: pending })
                        else
                            setSalaryItem({ ...salaryItem, amount: advance.remainingAdvance })
                    }
                    else if (salaryItem.amount < 0) {
                        setSalaryItem({ ...salaryItem, amount: 0 })
                    }
                }
                else {
                    setSalaryItem({ ...salaryItem, amount: 0 })
                }
            }
            else if (salaryItem.fromLedgerId == 45) {
                if (defect) {
                    if (salaryItem.amount > defect.remainingAdvance) {
                        if (defect.remainingAdvance > pending)
                            setSalaryItem({ ...salaryItem, amount: pending })
                        else
                            setSalaryItem({ ...salaryItem, amount: defect.remainingAdvance })
                    }
                    else if (salaryItem.amount < 0) {
                        setSalaryItem({ ...salaryItem, amount: 0 })
                    }
                }
                else {
                    setSalaryItem({ ...salaryItem, amount: 0 })
                }
            }
            else {
                if (salaryItem.amount > pending) {
                    setSalaryItem({ ...salaryItem, amount: pending })
                }
                else if (salaryItem.amount < 0) {
                    setSalaryItem({ ...salaryItem, amount: 0 })
                }
            }
        }
    }

    useEffect(() => {
        setAmount()
    }, [salaryItem.amount, salaryItem.fromLedgerId]);


    const AddItem = () => {
        if (salaryItem.amount > 0) {
            setIsLoadingMini(true);
            setIsLoadingLocal(true)
            salaryVoucherCrud.AddVoucherPayment(salaryItem)
                .then(res => {
                    if (res.data.succeeded) {
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false);
                        AppToaster('Added successfully.', 'success')
                        doRefresh()
                    }
                    else {
                        setIsLoadingMini(false)
                        setIsLoadingLocal(false);
                        AppToaster("Server Error /Invalid Try.", 'error')
                    }
                })
                .catch(error => {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    AppToaster(error, 'error')
                })
        }
        else {
            AppToaster("Amount should be greater than zero.", 'error')
        }
    }

    const DeleteItem = (id) => {
        setIsLoadingMini(true)
        salaryVoucherCrud.RemoveVoucherPayment(id)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false)
                    AppToaster('Deleted successfully.', 'success')
                    doRefresh()
                }
                else {
                    setIsLoadingMini(false)
                    AppToaster('Using by someone,could not delete.', 'error')
                }
            }).catch(error => {
                setIsLoadingMini(false)
                AppToaster('Network error', 'error')
            })
    }

    return (
        <>
            <div className="widget-box">
                <div class="widget-header widget-header-flat widget-header-small">
                    <h5 class="widget-title">
                        Details
                    </h5>
                </div>
                {
                    salaryVoucher &&
                    <div className="row">
                        <div class="profile-user-info profile-user-info-striped">
                            <div class="profile-info-row">
                                <div class="profile-info-name"> Voucher Id</div>

                                <div class="profile-info-value">
                                    <span ><b>{salaryVoucher.id}</b></span>
                                </div>
                            </div>

                            <div class="profile-info-row">
                                <div class="profile-info-name"> Voucher Date</div>

                                <div class="profile-info-value">
                                    <Moment format="DD-MMM-YYYY">{salaryVoucher.voucherDate}</Moment>
                                </div>
                            </div>

                            <div class="profile-info-row">
                                <div class="profile-info-name"> For Contact </div>

                                <div class="profile-info-value">
                                    <Link to={"/contact/dashboard/" + salaryVoucher.contact.id}>
                                        <ContactView item={salaryVoucher.contact} uid={"CXV1"} />
                                    </Link>
                                </div>
                            </div>
                            <div class="profile-info-row">
                                <div class="profile-info-name">Phone</div>

                                <div class="profile-info-value">
                                    <span >{salaryVoucher.contact.phone}</span>
                                </div>
                            </div>
                            <div class="profile-info-row">
                                <div class="profile-info-name">Address</div>

                                <div class="profile-info-value">
                                    <span >{salaryVoucher.contact.address}</span>
                                </div>
                            </div>
                            <div class="profile-info-row">
                                <div class="profile-info-name">Email</div>

                                <div class="profile-info-value">
                                    <span >{salaryVoucher.contact.email}</span>
                                </div>
                            </div>

                            <div class="profile-info-row">
                                <div class="profile-info-name">Amount</div>
                                <div class="profile-info-value">
                                    <span ><b>₹{Number(salaryVoucher.totalAmount).toFixed(2)}</b></span>
                                </div>
                            </div>
                            <div class="profile-info-row">
                                <div class="profile-info-name"> <b>Voucher Balance</b> </div>

                                <div class="profile-info-value">
                                    <span>Paid: <b className="green">₹{Number(paid).toFixed(2)}</b> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pending: <b className="red">₹{Number(pending).toFixed(2)}</b> </span>
                                </div>
                            </div>

                            <div class="profile-info-row">
                                <div class="profile-info-name">Status </div>

                                <div class="profile-info-value">
                                    <span><StatusView status={salaryVoucher.paymentStatus}>{GetEPaymentStatusName(salaryVoucher.paymentStatus)}</StatusView></span>
                                </div>
                            </div>

                            <div class="profile-info-row">
                                <div class="profile-info-name"> Created By </div>

                                <div class="profile-info-value">
                                    <span><UserView item={salaryVoucher.createdByUser} uid={"GD1"} createdOn={salaryVoucher.createdOn} /></span>
                                </div>
                            </div>

                        </div>
                    </div>
                }
            </div>
            <br />
            <div className="widget-box">
                <div class="widget-header widget-header-flat widget-header-small">
                    <h5 class="widget-title">
                        Voucher Payments
                    </h5>
                </div>

                <div className="row" >
                    <div class="col-xs-12">

                        <div className="col-md-3">
                            <div class="form-group">
                                <label class="control-label no-padding-right">Date</label>
                                <span class="input-icon" style={{ width: "100%" }}>
                                    <DatePicker placeholder="Received Date" name="receivedDate" className="form-control input-date-padding" selected={salaryItem.receivedDate} onChange={(date) => setSalaryItem({ ...salaryItem, receivedDate: date })} />
                                    <i class="ace-icon fa fa-calendar blue"></i>
                                </span>
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div class="form-group">
                                <label class="control-label no-padding-right"> Amount</label>
                                <input className="form-control" type="number" placeholder="Amount" value={salaryItem.amount} onChange={(e) => setSalaryItem({ ...salaryItem, amount: e.target.value })} />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div class="form-group">
                                <label class="ontrol-label no-padding-right">By</label>
                                <select className="form-control" value={salaryItem.fromLedgerId} onChange={(e) => setSalaryItem({ ...salaryItem, fromLedgerId: e.target.value })}>
                                    {
                                        GetELedgerAssetSalary.ELedgerAssetSalary.map((data, index) =>
                                            <option key={data.Id} value={data.Id}>{data.Name}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div class="form-group">
                                <label class="ontrol-label no-padding-right">Note</label>
                                <TextBoxTranslater className="form-control" type="text" placeholder="Note" value={salaryItem.note} onChange={(e) => setSalaryItem({ ...salaryItem, note: e.target.value })} />
                            </div>
                        </div>

                        <div className="col-md-2">
                            <div class="form-group">
                                <label class="control-label no-padding-right">&nbsp;</label>
                                <div class="col-xs-12">
                                    {isLoadingLocal ?
                                        <button class="btn btn-xs btn-success" type="submit" expand="block" disabled>
                                            <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i> Wait...
                                        </button>
                                        :
                                        <button class="btn btn-xs btn-success" type="submit" expand="block" onClick={AddItem}>
                                            <i class="ace-icon glyphicon glyphicon-plus bigger-110"></i>Pay
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />

                <div className="row">
                    <div className="col-xs-12">
                        <PagingEmpty text={"Total " + voucherPayment.length + " items."}>
                            {voucherPayment && voucherPayment.length > 0 ?
                                <div className="tables-scroll">
                                    <table className="table table-hover table-bordered">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>By</th>
                                                <th>Note</th>
                                                <th></th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {voucherPayment.map((item, index) =>
                                                <tr key={item.Id}>
                                                    <td>{index + 1}</td>
                                                    <td><Moment format="DD-MMM-YYYY">{item.receivedDate}</Moment></td>
                                                    <td><b>₹ {item.amount}</b></td>
                                                    <td>{GetELedgerAssetSalaryName(parseInt(item.fromLedgerId))}</td>
                                                    <td>{item.note}</td>
                                                    <td>
                                                        <div class="btn-group">
                                                            <MyAlert confirmBtnText="Yes, delete it!" title="Delete" onConfirm={DeleteItem} param={item.id}>
                                                                <i class="ace-icon fa fa-trash-o bigger-120"></i>
                                                            </MyAlert>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                :
                                <EmptyData>
                                    No Item Added.
                                    <br />
                                    <br />
                                </EmptyData>
                            }
                        </PagingEmpty>
                    </div>
                </div>
            </div>
        </>
    )
}

